import { RequiredColorPalette } from '../types';

// TODO: zakazat onst palette = {} as PaletteOptions;
const palette: RequiredColorPalette = { primary: { main: 'rgb(63, 81, 181)' } };

export default palette;
